<template>
  <info-layout>
    <div class="text-center">
      <div v-if="loading">
        <h1 class="mb-4">Preparing download file{{ fileName ? ` \`${fileName}\`` : '' }}...</h1>
        <b-spinner class="mt-5" variant="success" />
      </div>
      <div v-else>
        <a v-if="downloadUrl" :href="downloadUrl" class="btn btn-success" target="_self">Download</a>
        <h1 v-else class="mb-4">File is outdated or URL is invalid</h1>
      </div>
    </div>
  </info-layout>
</template>

<script lang="ts">
import { BSpinner } from 'bootstrap-vue-next'
import { defineComponent, ref, onMounted, type Ref, type ComputedRef, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useCommonStore } from '@/store/common'
import InfoLayout from '@/views/Layouts/InfoLayout.vue'

export default defineComponent({
  name: 'Download',
  components: {
    BSpinner,
    InfoLayout,
  },
  setup() {
    const route = useRoute()
    const commonStore = useCommonStore()

    const loading: ComputedRef<boolean> = computed(() => commonStore.loading)
    const downloadUrl: ComputedRef<string | null> = computed(() => commonStore.downloadUrl)
    const fileName: Ref<string | null> = ref(null)

    onMounted(async () => {
      const file = (route.query.reportFile || '') as string
      fileName.value = file
      if (!file) {
        return
      }
      commonStore.checkDownloadFile(file)
    })

    watch(downloadUrl, () => {
      if (downloadUrl.value) {
        window.open(downloadUrl.value, '_blank')
      }
    })

    return {
      loading,
      fileName,
      downloadUrl,
    }
  },
})
</script>
